module.exports = __webpack_public_path__ + "img/0Q3B7166_FoamcoreMatted.a0f1ce48.jpg";